export default "__VITE_ASSET__Cg5yJ05T__"